import { Menu } from "src/types";

class CommercialsStore {
  private _events: Array<any> = [];
  private _offers: Array<any> = [];
  private _menus: Array<any> = [];

  public get menus(): Array<any> {
    return this._menus;
  }

  public get forAllGuestsMenus(): Array<Menu> {
    return this._menus.filter(menu => menu.for_all_guests === true);
  }

  public get individualMenus(): Array<Menu> {
    return this._menus.filter(menu => menu.for_all_guests !== true);
  }

  public set menus(menus: Array<any>) {
    this._menus = menus;
  }

  public get offers(): Array<any> {
    return this._offers;
  }

  public set offers(offers: Array<any>) {
    this._offers = offers;
  }

  public get events(): Array<any> {
    return this._events;
  }

  public set events(events: Array<any>) {
    this._events = events;
  }
}

export const commercialsStore = new CommercialsStore();
